import { Binding, inject, Injectable, signal, Type } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { filter } from 'rxjs/operators';

export interface OverlayOpenProps<T> {
  type: 'drawer' | 'dialog';
  component: Type<T>;
  bindings?: Binding[];
  classes?: string;
}

@Injectable({
  providedIn: 'root',
})
export class TessOverlayService {
  #router = inject(Router);
  load = signal<OverlayOpenProps<unknown>>(null);
  result = signal<string | boolean | undefined>(undefined);

  #navigationEnd = this.#router.events.pipe(filter(event => event instanceof NavigationEnd));

  constructor() {
    this.#navigationEnd.subscribe(() => this.close());
  }

  open<T>(props: OverlayOpenProps<T>): void {
    this.load.set(props);
  }

  close(result?: string | boolean): void {
    this.load.set(null);
    this.result.set(result);
  }
}
